import React from "react";
// No import for Styles, it's removed

interface WesoTextInputProps {
  label?: string;
  placeholder?: string;
  onChangeText: (text: string) => void;
  value: string;
  name: string;
  secureTextEntry?: boolean;
  // keyboardType?: string; // Not used in web, but can keep if needed for RN compatibility
  className?: string; // Added for external margin/etc.
}

export const WesoTextInput: React.FC<WesoTextInputProps> = ({
  label,
  placeholder,
  onChangeText,
  value,
  name,
  secureTextEntry,
  // keyboardType,
  className,
}) => {
  return (
    <div className={`weso-text-input ${className || ""}`}>
      {label && (
        <label htmlFor={name} className="weso-text-input__label">
          {label}
        </label>
      )}
      <input
        type={secureTextEntry ? "password" : "text"}
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChangeText(e.target.value)
        }
        className="weso-text-input__input"
      />
    </div>
  );
};
